import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams,LoadingController,AlertController } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import {WaybillOrderServiceProvider} from '../../../providers/qdb/qdb-service';
import {DriverServiceProvider} from '../../../providers/dvm/driver-service';
import { Chart } from 'chart.js';

@Component({
  selector: 'page-driver-dashboard',
  templateUrl: 'index.html',
  providers: [WaybillOrderServiceProvider,DriverServiceProvider]
})
export class DriverDashboard {


   @ViewChild('barChart') barChart;
   @ViewChild('pieChart') pieChart;



  public obj:any;
  public cashPieChart:any;
  public data1:any;
  public start_time :string = new Date(new Date().getFullYear(), 0, 1).toISOString();
  public end_time :any = new Date().toISOString();
  public driver_id:any="4201601120624288819";
  public e_id:any="1";
  header_data:any;
   public drivers_list: any;

  selectedItem: any;
  icons: string[];
  items: Array<{title: string, note: string, icon: string}>;

  public dashboard_data: any;

  constructor(private alertCtrl: AlertController,public driverService: DriverServiceProvider,public datepipe: DatePipe,public navCtrl: NavController, public navParams: NavParams,public waybillOrderService: WaybillOrderServiceProvider,public loadingCtrl: LoadingController) {
 this.header_data={ismenu:true,ishome:false,title:"Driver Dashboard"};

        this.driverService.load_driver_list()
        .then(data => {
          console.log("driver_list_data");
          console.log(data);
          this.drivers_list = data;
        });
  }

  
searchDashboard(){

var input_start_time:any = this.datepipe.transform(this.start_time, 'yyyy-MM-dd');
var input_end_time:any = this.datepipe.transform(this.end_time, 'yyyy-MM-dd');
var driver_id:any = this.driver_id;
var e_id:any = this.e_id;


  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();
        this.waybillOrderService.get_driver_dashboard_data(input_start_time,input_end_time,driver_id,e_id)
        .then(data => {
             this.postRun(data);
        });
        loader.dismiss();
      }

postRun(data)
{
  if(data.records>0)
  {
  


        if(data.rows.length>0)
        {}

        if(data.invoices.length>0)
        {}

      
        this.createDriverBarChart(data);

          this.createDriverPieChart(data);
    
if(data.rows.length==0&&data.invoices.length==0)
{
    let alert = this.alertCtrl.create({
      title: 'Sorry',
      subTitle: "No Result Found",
      buttons: ['OK']
    });
    alert.present(prompt);
  
}
    }
    else{

    let alert = this.alertCtrl.create({
      title: 'Sorry',
      subTitle: "No Result Found",
      buttons: ['OK']
    });
    alert.present(prompt);
    }
 
}

/**
 *
 * Configure the Bar chart, define configuration options
 *
 */
createDriverBarChart(data)
{

       this.obj = data.total[this.driver_id];
       this.data1={};
       this.data1.labels=[];
       this.data1.datasets=[{backgroundColor:[],data:[],label: 'Parcels'}];
       
    this.data1.labels.push("Uncollected From Client ");
    this.data1.datasets[0].backgroundColor.push("#9199A9");
    this.data1.datasets[0].data.push(this.obj.number_of_not_picked_up_by_driver);

    this.data1.datasets[0].backgroundColor.push("#E0B19A");
    this.data1.datasets[0].data.push((this.obj.number_of_still_in_transit));
    this.data1.labels.push("Intranist To Collection Point");

    this.data1.datasets[0].backgroundColor.push("#B5BBC8");
    this.data1.datasets[0].data.push((this.obj.number_of_ready_for_return));
    this.data1.labels.push("Returns with Merchant");

    this.data1.datasets[0].backgroundColor.push("#EFBD76");
    this.data1.datasets[0].data.push((this.obj.rto_intransit_to_client)-(this.obj.rto_delivered_to_client));
    this.data1.labels.push("RTO instransit To Client");

         


   new Chart(this.barChart.nativeElement,
   {
     type: 'horizontalBar',
    data: this.data1,
    options: {
        "animation": {
            "duration": 1000,
            "onComplete": function() {
                var chartInstance = this.chart,
                    ctx = chartInstance.ctx;

                ctx.font = Chart.helpers.fontString(16, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';

                this.data.datasets.forEach(function(dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function(bar, index) {
                        var data = dataset.data[index];
                        ctx.fillText(data, bar._model.x, bar._model.y - 5);
                    });
                });
            }
        },
        maintainAspectRatio: false,
        legend: {
            display: true,
            boxWidth: 80,
            fontSize: 15,
            padding: 0
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    stepSize: 5,
                    max: 100
                }
            }],
            xAxes: [{
                ticks: {
                    autoSkip: false
                }
            }]
        }
      } 
  });
}





createDriverPieChart(data)
{

     this.obj = data.invoices[this.driver_id];
       this.data1={};
       this.data1.labels=[];
       this.data1.datasets=[{backgroundColor:[],data:[],label: 'COD'}];
       
    
         this.data1.labels.push("Collected ");
            this.data1.datasets[0].backgroundColor.push("#9199A9");
            this.data1.datasets[0].data.push(this.obj.collected);
         
          this.data1.labels.push("Uncollected ");
            this.data1.datasets[0].backgroundColor.push("#EFBD76");
            this.data1.datasets[0].data.push(this.obj.uncollected);



  this.cashPieChart = new Chart(this.pieChart.nativeElement,
   {
     type: 'pie',
    data: this.data1,
    options: {
        "animation": {
            "duration": 1000,
            "onComplete": function() {}
        },
        maintainAspectRatio: false,
        legend: {
            display: true,
            boxWidth: 80,
            fontSize: 15,
            padding: 0
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    stepSize: 5,
                    max: 100
                }
            }],
            xAxes: [{
                ticks: {
                    autoSkip: false
                }
            }]
        }
      } 
  });
}

  

}



// WEBPACK FOOTER //
// ./src/pages/qdb/driver-dashboard/index.ts